import React from "react";

export default function Separator({ className = "" }) {
  return (
    <div
      className={"h-px w-full border-b-2 border-gray-300 dark:border-white " + className}
    ></div>
  );
}
